import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionService } from 'app/services/models/transaction.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DecimalPipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { TransactionCreateDilaogComponent } from 'app/dialogs/transaction-create-dilaog/transaction-create-dilaog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TransactionUpdateDialogComponent } from 'app/dialogs/transaction-update-product-dialog/transaction-update-dialog.component';
import { TransactionUpdateComponent } from 'app/dialogs/transaction-update-dialog/transaction-update.component';
import { ProductService } from 'app/services/models/product.service';
import { TransactionProductService } from 'app/services/models/transaction-product.service';
import { UpdateTransacitonStatus } from 'app/dtos/Transaction/updateTransactionStatus';
import { SendpdfDialogComponent } from 'app/dialogs/sendpdf-dialog/sendpdf-dialog.component';
import { title } from 'process';
import { TransactionDescriptionService } from 'app/services/models/transaction-description.service';
import { SendPrintTransactionComponent } from 'app/dialogs/send-print-transaction/send-print-transaction.component';
import { AuthService } from 'app/services/auth.service';

@Component({
  selector: 'app-offer-detail',
  templateUrl: './offer-detail.component.html',
  styleUrls: ['./offer-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferDetailComponent implements OnInit {
  public contentHeader: object;
  public transaction: any = {};
  @BlockUI('section-block') blockUI: NgBlockUI;
  totalAmount: number | null = null;
  transactionList: any[] = []
  products: any[] = [];

  transactionCurrencyTotal: any[];

  public dateTimeStartOptions: FlatpickrOptions;
  public dateTimeEndOptions: FlatpickrOptions;

  date: Date;
  date2: Date;


  isDiscount: boolean = false;
  isPrivate: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private transactionService: TransactionService,
    private decimalPipe: DecimalPipe,
    private toastrService: ToastrService,
    private productService: ProductService,
    private transactionProductService: TransactionProductService,
    private router: Router,
    public authSerivce: AuthService
  ) { }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Teklif',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Teklif Listesi',
            isLink: true,
            link: '/offer'
          },
          {
            name: 'Teklif Detay',
            isLink: false,
          },
        ]
      }
    };

    this.dateTimeStartOptions = {
      altInput: true,
      enableTime: true,
      dateFormat: 'Y-m-d H:i',
      altFormat: 'd.m.Y H:i',
      locale: Turkish,
    };

    this.dateTimeEndOptions = {
      altInput: true,
      enableTime: true,
      dateFormat: 'Y-m-d H:i',
      altFormat: 'd.m.Y H:i',
      locale: Turkish,

    };
    await this.getAllProducts();
    this.transactionService.event$.subscribe(async result => {
      this.activatedRoute.params.subscribe(params => {
        this.getByIdTransaction(params['id']);
      });
    });

    this.activatedRoute.params.subscribe(params => {
      this.getByIdTransaction(params['id']);
    });
  }

  copyTranscation() {
    this.router.navigate(['/admin/create-offer', { data: JSON.stringify(this.transaction) }])
  }

  async getAllProducts() {
    const data = await this.productService.getAllProducts(0, 1000, '');
    console.log(data);
    this.products = data.products;
  }


  isPrivateDiscountToogle() {
    this.isDiscount = !this.isDiscount;
  }

  isPrivateToogle() {
    this.isPrivate = !this.isPrivate;

  }

  onProductChange(selectedProductId: number) {
    this.addProduct(selectedProductId);
  }

  sendEmail() {
    const modal = this.modalService.open(SendpdfDialogComponent, {
      size: 'ml',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      title: "Teklif Şablonu.",
      description: "Merhaba, aşşağıdaki teklif incelemeniz için tarafınıza sunulmuştur.",
      transactionId: this.transaction?.id
    };
  }

  hasTransactionFeatures(): boolean {
    return this.transaction?.transactionList?.some(t => t.transactionAdditionalFeatureMatchings?.length > 0) ?? true;
  }

  sendPrint() {
    const modal = this.modalService.open(SendPrintTransactionComponent, {
      size: 'xs',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {

      transactionId: this.transaction?.id
    };
  }

  addProduct(product) {
    const modal = this.modalService.open(TransactionCreateDilaogComponent, {
      size: 'lg',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      message: `${product.name}`,
      product: product,
      discountRate: this.transaction?.discountRate,
      transactionId: this.transaction?.id
    };

    modal.result.then((result) => {
      if (result) {
        this.transactionList.push(result);
        console.log("İşlem Listesi: ", this.transactionList);
        this.calculateTotalAmount();
        this.calculateVatTotals(this.transactionList);
        this.calculatePurchaseTaxTotals(this.transactionList);
        this.calculateNetVatDifference(this.transactionList);
        this.calculateNetDifference(this.transactionList);
      }
    }, (reason) => {
      console.log('Modal kapatıldı:', reason);

    });
  }

  async getByIdTransaction(id) {
    this.blockUI.start('Teklif Yükleniyor..');
    const data = await this.transactionService.getByIdTransaction(id);
    console.log(data);
    if (data.kindId !== 8) {
      this.blockUI.stop();
      this.router.navigate(['/admin/offer']);
      this.toastrService.error('Böyle bir teklif yok');
      return; // Eğer kindId 5 değilse, işlemi durdurur
    }
    else {
      this.transaction = data;
      this.transactionList = this.transaction.transactionManagementProducts; // Assuming transactions are part of the response
      this.calculateTotalAmount();
      this.calculateTaxAndDiscountTotals(this.transactionList);
      this.calculateTotalsByCurrency(this.transactionList);
    }

    this.blockUI.stop();
  }

  async updateTransactionStatus(id, kindId, status) {
    const updateStatus = new UpdateTransacitonStatus();
    updateStatus.id = id;
    updateStatus.kindId = kindId;
    updateStatus.status = status;
    if (status == 5) {
      const allCurrenciesMatch = this.transactionList.every(p => p.currencyId === this.transaction.companyCurrencyId);
      if (allCurrenciesMatch) {
        const response = await this.transactionService.UpdateTransactionStatus(updateStatus);

        if (response.status === true) {
          if (status === 2) {
            this.transactionService.sendEvent(true);
          } else {
            this.router.navigate(['/admin/sales-detail', id]);
          }
          this.toastrService.success(response.message);
        } else {
          this.toastrService.error(response.message);
        }
      } else {
        this.transactionList.forEach(async p => {
          if (p.currencyId !== this.transaction.companyCurrencyId) {
            this.toastrService.error(`${p.productName} bu ürün firma para birimi ile eşleşmiyor.`)
          }
        });
      }
    } else {
      const response = await this.transactionService.UpdateTransactionStatus(updateStatus);
      if (response.status == true) {
        if (status == 2) {
          this.transactionService.sendEvent(true);
        } else {
          this.router.navigate(['/admin/sales-detail', id])
        }
        this.toastrService.success(response.message);
      } else {
        this.toastrService.error(response.message);
      }
    }
  }

  getKindText(kindId: number): string {
    switch (kindId) {
      case 8:
        return 'Teklif';
      case 7:
        return 'Sipariş';
      case 5:
        return 'Alış';
      case 6:
        return 'Satış';
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  getStatusText(status: number, kindId: number): string {
    const kindText = this.getKindText(kindId);
    switch (status) {
      case 1:
        return `${kindText} Oluşturuldu`;
      case 2:
        return `${kindText} İptal Edildi`;
      case 3:
        return `${kindText} Onaylandı`;
      case 4:
        return `${kindText} Reddedildi`;
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  getStatusClass(status: number): string {
    switch (status) {
      case 1:
        return 'badge badge-info';    // Info class for status 1
      case 2:
        return 'badge badge-danger';  // Danger class for status 2
      case 3:
        return 'badge badge-success'; // Success class for status 3
      case 4:
        return 'badge badge-warning'; // Warning class for status 4
      default:
        return 'badge badge-secondary'; // Secondary class for unknown status
    }
  }

  showUpdateTransaction(id) {
    const transactionProductDetail = this.authSerivce.isEndpointStatus('GET.Reading.GetByIdTransactionProducts');
    if (transactionProductDetail) {
      const modal = this.modalService.open(TransactionUpdateDialogComponent, {
        size: 'lg',
        centered: true,
        windowClass: 'modal modal-success'
      });
      modal.componentInstance.data = id;
    }else{
      this.toastrService.error("Yetkiniz yok ürün detayını görmeye");
    }
  }

  updateTransaction(id) {
    const modal = this.modalService.open(TransactionUpdateComponent, {
      size: 'ml',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = id;
  }

  calculateTotalAmount() {

    if (Array.isArray(this.transactionList)) {
      this.totalAmount = this.transactionList.reduce((acc, transaction) => {
        // Debugging line to check each transaction's total
        return acc + (transaction.total || 0);
      }, 0);
    } else {

      this.totalAmount = 0;
    }
  }

  transactionDiscountTotal: any[];

  calculateTaxAndDiscountTotals(transactions) {
    if (!transactions || transactions.length === 0) {
      return [];
    }

    const totalsMap: { [taxId: number]: { taxRate: number, totalDiscount: number, totalTax: number } } = {};

    transactions.forEach(transaction => {
      const { taxId, taxRate, productPrice, productCount, discountRate } = transaction;

      const totalPrice = productPrice * productCount;
      const discountAmount = (totalPrice * discountRate) / 100;
      const priceAfterDiscount = totalPrice - discountAmount;
      const taxAmount = (priceAfterDiscount * taxRate) / 100;

      if (!totalsMap[taxId]) {
        totalsMap[taxId] = { taxRate, totalDiscount: 0, totalTax: 0 };
      }

      totalsMap[taxId].totalDiscount += discountAmount;
      totalsMap[taxId].totalTax += taxAmount;
    });

    this.transactionDiscountTotal = Object.keys(totalsMap).map(taxId => ({
      taxId: +taxId,
      taxRate: totalsMap[+taxId].taxRate,
      totalDiscount: totalsMap[+taxId].totalDiscount,
      totalTax: totalsMap[+taxId].totalTax
    }));

    console.log(this.transactionDiscountTotal);
    return this.transactionDiscountTotal;
  }


  calculateTotalsByCurrency(transactions) {
    if (!transactions || transactions.length === 0) {
      return [];
    }

    const totalsMap: { [currencyId: number]: { currency: string, totalAmount: number } } = {};

    transactions.forEach(transaction => {
      const { currencyId, currency, productPrice, productCount, discountRate, taxRate } = transaction;

      const totalPrice = productPrice * productCount;
      console.log(totalPrice);
      const discountAmount = (totalPrice * discountRate) / 100;
      console.log(discountAmount);

      const priceAfterDiscount = totalPrice - discountAmount;
      const taxAmount = (priceAfterDiscount * taxRate) / 100;
      const finalAmount = priceAfterDiscount + taxAmount;

      if (!totalsMap[currencyId]) {
        totalsMap[currencyId] = { currency, totalAmount: 0 };
      }

      totalsMap[currencyId].totalAmount += finalAmount;
    });

    this.transactionCurrencyTotal = Object.keys(totalsMap).map(currencyId => ({
      currencyId: +currencyId,
      currency: totalsMap[+currencyId].currency,
      totalAmount: +totalsMap[+currencyId].totalAmount.toFixed(2) // Virgülden sonra iki basamak
    }));

    console.log(this.transactionCurrencyTotal);
    return this.transactionCurrencyTotal;
  }

  updateTransactions(newTransactions: any[]) {
    this.transactionList = newTransactions;
    this.calculateTotalAmount();
  }

  async deleteTransaction(index: number) {
    if (index) {
      const response = await this.transactionProductService.transactionProductRemove(index);
      if (response.status == true) {
        this.toastrService.success(response.message);
        this.transactionService.sendEvent(true);
      } else {
        this.toastrService.error(response.message);
      }
    } else {
      this.toastrService.error("Yanlış bir butona bastınız.");
    }
  }

  sumCount(): number {
    return this.transactionList.reduce((total, transaction) => total + (transaction.productCount || 0), 0);
  }

  sumGross(): number {
    return this.transactionList.reduce((total, transaction) => total + (transaction.productPrice * transaction.productCount || 0), 0);
  }

  sumDiscount(): number {
    return this.transactionList.reduce((total, transaction) => total + (((transaction.productPrice * transaction.productCount) * transaction.discountRate) / 100 || 0), 0);
  }

  sumBuyingCount(): number {
    return this.transactionList.reduce((total, transaction) => total + ((transaction.product.purchasePrice * transaction.productCount) || 0), 0);
  }

  sumExcludingVAT(): number {
    const totalNet = this.sumNetTotal();
    const totalPurchasePrice = this.transactionList.reduce((total, transaction) => total + (transaction.product.purchasePrice * transaction.productCount), 0);
    return totalNet - totalPurchasePrice;
  }

  calculateVatTotals(transactions): { saleTaxId: number, saleTax: number, totalVat: number }[] {
    const vatTotalsMap: { [saleTaxId: number]: { saleTax: number, totalVat: number } } = {};

    transactions.forEach(transaction => {
      const { saleTaxId, salePrice, productCount, saleTax } = transaction;
      const totalBeforeVat = salePrice * productCount;
      const vat = (totalBeforeVat * saleTax) / 100;

      if (!vatTotalsMap[saleTaxId]) {
        vatTotalsMap[saleTaxId] = { saleTax, totalVat: 0 };
      }

      vatTotalsMap[saleTaxId].totalVat += vat;
    });

    return Object.keys(vatTotalsMap).map(saleTaxId => ({
      saleTaxId: +saleTaxId,
      saleTax: vatTotalsMap[+saleTaxId].saleTax,
      totalVat: vatTotalsMap[+saleTaxId].totalVat
    }));
  }

  calculateNetVatDifference(transactions): number {
    const vatTotals = this.calculateVatTotals(transactions);
    const totalSalesVat = vatTotals.reduce((total, item) => total + item.totalVat, 0);
    const purchaseTaxTotals = this.calculatePurchaseTaxTotals(transactions);
    const totalPurchaseVat = purchaseTaxTotals.reduce((total, item) => total + item.totalPurchaseTax, 0);
    const netVatDifference = totalSalesVat - totalPurchaseVat;
    this.toastrService.info(`Net VAT Difference: ${netVatDifference}`);
    return netVatDifference;
  }

  calculatePurchaseTaxTotals(transactions): { purchaseTaxId: number, purchaseTax: number, totalPurchaseTax: number }[] {
    const purchaseTaxTotalsMap: { [purchaseTaxId: number]: { purchaseTax: number, totalPurchaseTax: number } } = {};

    transactions.forEach(transaction => {
      const { product, productCount } = transaction;
      const { purchaseTaxId, purchasePrice, purchaseTax } = product;
      const totalBeforeTax = purchasePrice * productCount;
      const purchaseTaxAmount = (totalBeforeTax * purchaseTax) / 100;

      if (!purchaseTaxTotalsMap[purchaseTaxId]) {
        purchaseTaxTotalsMap[purchaseTaxId] = { purchaseTax, totalPurchaseTax: 0 };
      }

      purchaseTaxTotalsMap[purchaseTaxId].totalPurchaseTax += purchaseTaxAmount;
    });

    return Object.keys(purchaseTaxTotalsMap).map(purchaseTaxId => ({
      purchaseTaxId: +purchaseTaxId,
      purchaseTax: purchaseTaxTotalsMap[+purchaseTaxId].purchaseTax,
      totalPurchaseTax: purchaseTaxTotalsMap[+purchaseTaxId].totalPurchaseTax
    }));
  }

  sumNetTotal(): number {
    return this.transactionList.reduce((total, transaction) => {
      const totalPrice = transaction.productPrice * transaction.productCount;
      const discount = (totalPrice * transaction.discountRate) / 100;
      return total + (totalPrice - discount);
    }, 0);
  }

  calculateNetDifference(transactions): number {
    const salePriceTotal = transactions.reduce((total, transaction) => total + (transaction.total || 0), 0);
    const purchasePriceTotal = transactions.reduce((total, transaction) => {
      const { product, productCount } = transaction;
      const { purchasePrice, purchaseTax } = product;
      const totalPurchasePriceWithTax = (purchasePrice + ((purchasePrice * purchaseTax) / 100)) * productCount || 0;
      return total + totalPurchasePriceWithTax;
    }, 0);

    const netDifference = salePriceTotal - purchasePriceTotal;
    this.toastrService.info(`Net Difference: ${netDifference}`);
    return netDifference;
  }

  calculateGeneralTotal(): number {
    return this.transactionList.reduce((total, transaction) => {
      // Ensure we have valid values and parse them to floats
      const productPrice = parseFloat(transaction.productPrice) || 0;
      const productCount = parseFloat(transaction.productCount) || 0;
      const discountRate = parseFloat(transaction.discountRate) || 0; // Discount rate as a percentage
      const saleTax = parseFloat(transaction.taxRate) || 0; // VAT rate as a percentage
      // Calculate the total price for this product before any discounts
      const productTotalPrice = productPrice * productCount;

      // Calculate the discount amount
      const discount = (productTotalPrice * discountRate) / 100;

      // Calculate the net price after applying the discount
      const netPrice = productTotalPrice - discount;

      // Calculate VAT based on the net price
      const vat = (netPrice * saleTax) / 100;

      // Add the net price and VAT to the total
      return total + netPrice + vat;
    }, 0);
  }


  formatNumber(value: number): string {
    return this.decimalPipe.transform(value, '1.2-2') || '0.00';
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // Ctrl tuşu basılı mı ve 'P' tuşuna mı basıldı?
    if (event.ctrlKey && event.key === 'p') {
      event.preventDefault(); // Tarayıcının varsayılan baskı penceresini açmasını engelleyin
      this.sendPrint(); // sendPrint fonksiyonunu çağırın
    }
  }
}
